'use strict';

import { view } from '@/functions';

const prefix = '/dashboard';
const sales_scopes = ['read_sales_commissions', 'read_charts_salespeople'];
const sales_overview_scopes = ['read_sales_overview'];
const customer_success_scopes = ['read_customer_success'];
// Regional/state managers and sales reps always see their own state and sales team, regardless of scopes.
const sales_team_positions = ['regional_manager', 'state_manager', 'sales'];
const inbound_positions = ['inbound_sales', 'inbound_team_leader'];
// Customer success reps see their own portfolio; their managers see their reps, regardless of scopes.
const customer_success_positions = ['customer_success', 'state_manager', 'partner_manager', 'inbound_team_leader'];
const salesSection = {
	render() {
		return null;
	},
};

export default [
	{
		path: prefix,
		name: 'dashboard',
		meta: {
			title: 'Dashboard',
		},
		component: () => view('dashboard/index')
	},
	{
		path: `${prefix}/sales`,
		component: () => view('dashboard/sales'),
		meta: {
			title: 'Sales',
			scopes: sales_scopes,
			bypassPositions: sales_team_positions,
		},
		children: [
			{
				path: 'home',
				name: 'sales-home',
				component: salesSection,
				meta: {
					title: 'Sales',
					scopes: sales_scopes,
					bypassPositions: sales_team_positions,
				},
			},
			{
				path: 'overview',
				redirect: (to) => ({ name: 'sales-overview', query: to.query }),
			},
			{
				path: 'customers',
				name: 'sales-customers',
				component: salesSection,
				meta: {
					title: 'Sales',
					scopes: sales_scopes,
					bypassPositions: sales_team_positions,
				},
			},
			{
				path: 'charts',
				name: 'sales-charts',
				component: salesSection,
				meta: {
					title: 'Sales',
					scopes: sales_scopes,
					bypassPositions: sales_team_positions,
				},
			},
			{
				path: 'commissions',
				name: 'sales-commission-dashboard',
				component: salesSection,
				meta: {
					title: 'Sales',
					scopes: sales_scopes,
					bypassPositions: sales_team_positions,
				},
			},
		],
	},
	{
		path: `${prefix}/sales-overview`,
		name: 'sales-overview',
		meta: {
			title: 'Sales overview',
			scopes: sales_overview_scopes,
			bypassPositions: [...sales_team_positions, 'inbound_team_leader'],
		},
		component: () => view('dashboard/sales-overview'),
	},
	{
		path: `${prefix}/customer-success`,
		component: () => view('dashboard/customer-success'),
		meta: {
			title: 'Customer success',
			scopes: customer_success_scopes,
			bypassPositions: customer_success_positions,
		},
		children: [
			{
				path: 'commissions',
				name: 'customer-success',
				component: salesSection,
				meta: {
					title: 'Customer success',
					scopes: customer_success_scopes,
					bypassPositions: customer_success_positions,
				},
			},
			{
				path: 'customers',
				name: 'customer-success-customers',
				component: salesSection,
				meta: {
					title: 'Customer success',
					scopes: customer_success_scopes,
					bypassPositions: customer_success_positions,
				},
			},
			{
				path: 'charts',
				name: 'customer-success-charts',
				component: salesSection,
				meta: {
					title: 'Customer success',
					scopes: customer_success_scopes,
					bypassPositions: customer_success_positions,
				},
			},
			{
				path: 'home',
				name: 'customer-success-home',
				component: salesSection,
				meta: {
					title: 'Customer success',
					scopes: customer_success_scopes,
					bypassPositions: customer_success_positions,
				},
			},
		],
	},
	{
		path: `${prefix}/inbound-sales`,
		component: () => view('dashboard/inbound-sales'),
		meta: {
			title: 'Inbound sales',
			scopes: sales_scopes,
			bypassPositions: inbound_positions,
		},
		children: [
			{
				path: 'commissions',
				name: 'inbound-sales',
				component: salesSection,
				meta: {
					title: 'Inbound sales',
					scopes: sales_scopes,
					bypassPositions: inbound_positions,
				},
			},
			{
				path: 'customers',
				name: 'inbound-sales-customers',
				component: salesSection,
				meta: {
					title: 'Inbound sales',
					scopes: sales_scopes,
					bypassPositions: inbound_positions,
				},
			},
			{
				path: 'charts',
				name: 'inbound-sales-charts',
				component: salesSection,
				meta: {
					title: 'Inbound sales',
					scopes: sales_scopes,
					bypassPositions: inbound_positions,
				},
			},
			{
				path: 'home',
				name: 'inbound-sales-home',
				component: salesSection,
				meta: {
					title: 'Inbound sales',
					scopes: sales_scopes,
					bypassPositions: inbound_positions,
				},
			},
		],
	},
	{
		path: `${prefix}/mongodb`,
		name: 'dashboard mongodb',
		meta: {
			title: 'MongoDB dashboard',
			scopes: ['read_dashboard_mongodb']
		},
		component: () => view('dashboard/mongodb')
	},
	{
		path: `${prefix}/profile`,
		name: 'profile',
		meta: {
			title: 'Profile',
		},
		component: () => view('dashboard/profile')
	},
	{
		path: `${prefix}/notifications`,
		name: 'dashboard-notifications',
		meta: {
			title: 'Notifications',
		},
		component: () => view('dashboard/notifications')
	},
];
